<template src="./pageLoading.template.html"></template>
<script type="text/javascript">
    import moment from 'moment-timezone'

    export default {
        name: "pageLoadingComponent",
        props: [],
        data() {
            return {
                
            };
        },
        methods: {
           
        },
        computed: {
            
        },
        mounted() {
           
        },
        watch: {
            
        }
    };

</script>


// WEBPACK FOOTER //
// src/components/pageLoadingComponent/pageLoading.vue